import React from 'react';
import moment from 'moment';

import NotesIcon from '../../../assets/icons/NotesIcon';
import AddButton from '../../shared/AddButton';

import './surgeon-page.scss';
import userRoles from '../../../constants/userRoles';
import EditIcon from '../../../assets/icons/EditIcon';
import DeleteIcon from '../../../assets/icons/DeleteIcon';

const SurgeonNotes = (props) => {
  const { notes = [], onAddClick, onEditClick, onDeleteClick, currentUser, tenantColor } = props;

  return (
    <div className="surgeon-notes__container">
      <div className='d-flex space-between p-t-md p-b-md p-l-lg p-r-md'>
        <div className='d-flex'>
          <NotesIcon color="var(--app-text)" />
          <div className='m-l-md font-bold font-size-lg'>
            Surgeon Notes
          </div>
        </div>
        <AddButton onClick={() => onAddClick(true)} />
      </div>
      <div className='surgeon-notes__surgeon-notes-list'>
        {notes?.length ? (
          notes?.map((item) => (
            <div key={item.id} className='surgeon-notes__surgeon-note'>
              <div className='d-flex space-between'>
                <div className='font-bold'>{item.authorFullName}</div>
                <div className='d-flex'>
                  <div className='secondary'>{moment(item.createdAt).fromNow()}</div>
                  {(currentUser?.role === userRoles.ADMIN.name || currentUser?.uid === item.authorId) && (
                    <div className='m-l-sm d-flex'>
                      <div className='pointer' onClick={() => onEditClick(item)}>
                        <EditIcon color={tenantColor} fontSize='small' />
                      </div>
                      <div className='pointer m-l-md' onClick={() => onDeleteClick(item)}>
                        <DeleteIcon color="#F53434" fontSize='small' />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='m-t-md'>
                {item.note}
              </div>
              {!!item?.attachments?.length && (
                <div style={{ marginTop: 12 }} className='d-flex'>
                  {item?.attachments?.map((item) => (
                    <div
                      key={`${item.id}_${item.fileName}`}
                      style={{ width: 50, height: 50, borderRadius: 8, marginRight: 4 }}
                      className='m-r-lg pointer'
                      onClick={() => window.open(item.downloadUrl, '_blank')}
                    >
                      <img
                        src={item.downloadUrl}
                        alt='preference-preview'
                        style={{ width: 50, height: 50, borderRadius: 8 }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className='p-lg font-size-bg font-bold secondary d-flex flex-center'>
            No Notes
          </div>
        )}
      </div>
    </div>
  );
};

export default SurgeonNotes;
